import { DateTime } from 'luxon';

/**
 * @example
 * dateFromNow(31) -> "2020-11-06"
 * @param {number} daysFromNow
 * @returns {string}
 */
export function dateFromNow(daysFromNow) {
  const date = new Date();
  date.setDate(date.getDate() + daysFromNow);
  return date.toISOString().substring(0, 10);
}

export function percentageUsed(startDate, endDate) {
  const start = DateTime.fromISO(startDate);
  const end = DateTime.fromISO(endDate);
  const totalDiff = start.diff(end);
  const elapsedDiff = start.diffNow();
  const now = DateTime.local();

  if (start > now) {
    return 0;
  }

  if (end < now) {
    return 100;
  }

  return ((elapsedDiff / totalDiff) * 100).toFixed(1);
}

export function percentageLeft(startDate, endDate) {
  return Math.max(0, 100 - percentageUsed(startDate, endDate)).toFixed(1);
}

/**
 * Formats date to a human-readable format with Luxon.
 * @param {String|Luxon.DateTime} date Date to format
 * @param {Luxon.DateTime} [format=Luxon.DateTime.DATE_MED]
 * format preset from {@link https://moment.github.io/luxon/docs/class/src/datetime.js~DateTime.html#instance-method-toLocaleString|Luxon}
 * @returns {String} Formatted date
 */
export function toLocaleDateString(date, format = DateTime.DATE_MED) {
  if (DateTime.isDateTime(date)) {
    return date.toLocaleString(format);
  }

  return DateTime.fromISO(date).toLocaleString(format);
}

/**
 * Determines if date is in the future.
 * @param {String|Luxon.DateTime} date Date to evaluate
 * @returns {boolean} Whether date is in the future
 */
export function isFutureDate(date) {
  if (DateTime.isDateTime(date)) {
    return date.diffNow() > 0;
  }

  return DateTime.fromISO(date).diffNow() > 0;
}
